import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { FetchOlaMapsLocationByPlaceIDType } from "../../../domain/models/ola-maps/fetch-ola-maps-location-by-place-id";
import { FetchOlaMapsLocationByPlaceID } from "../../../domain/useages/ola-maps/fetch-ola-maps-location-by-place-id";
import { RemoteFetchOlaMapsLocationByPlaceID } from "../../../data/usecases/ola-maps/remote-fetch-ola-maps-location-by-place-id";

export interface FetchOlaMapsLocationByPlaceIDInterface {
    FetchOlaMapsLocationByPlaceID: FetchOlaMapsLocationByPlaceIDType;
    FetchOlaMapsLocationByPlaceIDState: FetchState;
    fetchOlaMapsLocationByPlaceID: Function;
}

const initialStates = {
  FetchOlaMapsLocationByPlaceID: {} as FetchOlaMapsLocationByPlaceIDType,
  FetchOlaMapsLocationByPlaceIDState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchOlaMapsLocationByPlaceIDSlice: StateCreator<
  FetchOlaMapsLocationByPlaceIDInterface
> = (set) => ({
  ...initialStates,
  fetchOlaMapsLocationByPlaceID: async (
    filter: FetchOlaMapsLocationByPlaceID.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchOlaMapsLocationByPlaceID =
      new RemoteFetchOlaMapsLocationByPlaceID(
        `${BASE_URL}${Endpoints.FETCH_OLA_MAPS_LOCATION_BY_PLACE_ID}`,

        axiosHttpClient
      );

    set(() => ({ FetchOlaMapsLocationByPlaceIDState: FetchState.LOADING }));
    let result = await remoteFetchOlaMapsLocationByPlaceID.fetch(filter);
    return result;
  },
});
